<script>
import FileField from '@/fields/Form/FileField'

export default {
  extends: FileField,
}
</script>
